const HomeIcon = (props) => {
  return (
    <svg className={props.className} width="54" height="54" viewBox="0 0 54 54" fill="none" stroke="#486F88" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 22.844L26.657 13.001L39.314 22.845V38.315C39.314 39.061 39.0176 39.7765 38.4901 40.3041C37.9626 40.8316 37.2471 41.128 36.501 41.128H16.813C16.4435 41.1281 16.0775 41.0554 15.7361 40.914C15.3947 40.7726 15.0845 40.5654 14.8233 40.304C14.562 40.0427 14.3548 39.7324 14.2136 39.3909C14.0723 39.0495 13.9997 38.6835 14 38.314V22.844Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.438 41.125V27.064H30.876V41.125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export default HomeIcon;
